module.exports = __webpack_public_path__ + "img/ic_publicity_detail8_2.a8c67805.jpg";